import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "aos/dist/aos.css";
import "swiper/css/bundle";
import "flatpickr/dist/flatpickr.css";
import "intl-tel-input/styles";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { phoneInputs } from "./modules/phone.js";
import { initTheme } from "./modules/theme";
import { initPersonalInfo } from "./modules/personal-info";
import { initPromoCode } from "./modules/promo-code";
import { disableFormOnSubmit } from "./modules/form-submit";



import "../scss/app.scss";
import "./modules/theme.js";
import "./modules/aos.js";
import "./modules/swiper.js";
import "./modules/navbar.js";
import "./modules/fancybox.js";
import "./modules/demo.js";
import "./modules/validation.js";
import "./modules/help.js";
import "./modules/sign-up.js"
import "./modules/confirm-email.js"
import "./modules/profile.js";
import "./modules/cookie-notice.js";

// YOUR files are deliberately imported last.
import "../css/custom.css";
import "./modules/pricing.js";

import "./custom.js";


document.addEventListener("DOMContentLoaded", () => {
    phoneInputs();
    initTheme();
    initPersonalInfo();
    initPromoCode();
    disableFormOnSubmit();
});
